/**
 * Base URL for backend API calls.
 *
 * Production: CI sets REACT_APP_API_BASE (Azure Web App URL) at build time.
 *
 * Local dev: leave REACT_APP_API_BASE unset or blank in frontend/.env so
 * requests go to the same origin (e.g. http://localhost:3000/api/...) and
 * Create React App's "proxy" in package.json forwards them to the backend
 * (see proxy → 127.0.0.1:5001). No CORS setup needed.
 *
 * Alternatively set REACT_APP_API_BASE=http://localhost:5001 to call the API directly.
 */
export function apiUrl(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const base = (process.env.REACT_APP_API_BASE || "").trim().replace(/\/$/, "");
  if (base) return `${base}${normalized}`;
  return normalized;
}
